import React from 'react'
import PropTypes from 'prop-types'
import {Card} from 'antd'
import {FullscreenOutlined} from '@ant-design/icons'

function formatKm(km) {
  return `${km.toFixed(1)} km`
}

const AvailableAreaPhotos = ({photos, onPhotoClick}) => {
  if (!photos.length) {
    return <div>Ingen resultater</div>
  }

  return (
    <div className="image-cards">
    {
      photos.map(({node: photo}, photoIndex) => {
        return (
          <Card
            key={photoIndex}
            hoverable
            className="image-card"
            onClick={() => onPhotoClick({photoIndex, photo})}
            cover={
              <div className="image-card-inner-wrapper">
                <img
                  alt={photo.name}
                  src={photo.thumb.url}
                />
              </div>
            }
          >
            <Card.Meta
              description={
                <div className="image-card-description">
                  <FullscreenOutlined />

                  <div className="name">
                    {photo.name}
                  </div>
                  {formatKm(photo.distanceInKm)}
                </div>
              }
            />
          </Card>
        )
      })
    }
    </div>
  )
}

AvailableAreaPhotos.propTypes = {
  photos: PropTypes.array.isRequired,
  onPhotoClick: PropTypes.func,
}

export default AvailableAreaPhotos
